import { gateway } from "../../../gateway";

export const cancelInvitation = async (uid: string, companyId?: number) => {
  const res = await gateway.post(`/invitations/${uid}/cancel`, undefined, {
    headers:
      companyId !== undefined
        ? {
            "x-company-id": companyId,
          }
        : undefined,
  });

  return res.data;
};
